export enum CemocCategory {
    CompetitivePerformance = 'CompetitivePerformance',
    Tailwind = 'Tailwind',
    Headwind = 'Headwind',
    ScopeIncreaseCY = 'ScopeIncreaseCY',
    ScopeDecreaseCY = 'ScopeDecreaseCY',
}

export const CemocCategoryLabels: Record<CemocCategory | string, string> = {
    CompetitivePerformance: 'Competative Performance',
    Tailwind: 'Tailwind',
    Headwind: 'Headwind',
    ScopeIncreaseCY: 'Scope Increase (CY)',
    ScopeDecreaseCY: 'Scope Decrease (CY)',
};
